// Importing action types
import {
  FETCH_JOB_APPLY_REQUEST,
  FETCH_JOB_APPLY_SUCCESS,
  FETCH_JOB_APPLY_FAILURE,
} from "../../actions/fetchJobApplyActions";

// Define the initial state for the reducer
const initialState = {
  isJobApplyItem: null,  // Initial value for isJobApplyItem is null
  isLoading: false,    // Initial value for isLoading is false
  isError: null,       // Initial value for isError is null
};

// Define the JobApplyDataReducer function
const JobApplyDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JOB_APPLY_REQUEST:
      // When the FETCH_JOB_APPLY_REQUEST action is dispatched
      return {
        ...state,
        isLoading: true,   // Set isLoading to true
        isError: null,     // Reset isError to null
      };
    case FETCH_JOB_APPLY_SUCCESS:
      // When the FETCH_JOB_APPLY_SUCCESS action is dispatched
      return {
        ...state,
        isJobApplyItem: action.payload,  // Update isJobApplyItem with the payload from the action
        isLoading: false,              // Set isLoading to false
        isError: null,                 // Reset isError to null
      };
    case FETCH_JOB_APPLY_FAILURE:
      // When the FETCH_JOB_APPLY_FAILURE action is dispatched
      return {
        ...state,
        isLoading: false,              // Set isLoading to false
        isError: action.payload,       // Update isError with the payload from the action
      };
    default:
      // If none of the above action types match, return the current state
      return state;
  }
};

export default JobApplyDataReducer;
